import { render, staticRenderFns } from "./ThePreviousEditionsCarousel.vue?vue&type=template&id=19edf21c&scoped=true&"
import script from "./ThePreviousEditionsCarousel.vue?vue&type=script&lang=js&"
export * from "./ThePreviousEditionsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ThePreviousEditionsCarousel.vue?vue&type=style&index=0&id=19edf21c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19edf21c",
  null
  
)

export default component.exports